// Polyfill: expose process as a global for legacy code that reads window.process.
// This file is loaded first in the webpack entry bundle.
import process from 'process/browser';
window.process = process;
